import { c as _c } from "react/compiler-runtime";
import { Lock } from "lucide-react";

// Public env so the shown URL matches the real tenant domain format.
const ROOT_DOMAIN = process.env.NEXT_PUBLIC_BETTER_AUTH_DOMAIN ?? "gym-mart.xyz";

// Faux browser address bar — shows each gym gets its own branded subdomain,
// the headline selling point, rendered as a mini URL chip.
export const HeroSubdomainChip = () => {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <span className="hidden items-center gap-1 sm:flex"><span className="size-2 rounded-full bg-zinc-300" /><span className="size-2 rounded-full bg-zinc-300" /><span className="size-2 rounded-full bg-zinc-300" /></span>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div><div className="inline-flex items-center gap-2.5 rounded-full border border-border/70 bg-card px-3.5 py-2 shadow-sm">{t0}<span className="flex items-center gap-1.5 text-sm"><Lock className="size-3.5 text-primary" /><span className="font-semibold text-primary">yourgym</span><span className="text-muted-foreground">.{ROOT_DOMAIN}</span></span></div><p className="mt-2 text-xs text-muted-foreground">Your gym’s own private site — your name on the door.</p></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};